import { JoinTypeEnum } from 'src/app/reports/enums/join-type.enum';

export class RelatedEntity {
    ReportEntityId?: number;
    EntityId: number;
    EntityAlias: string;
    ColumnName: string;
    JoinType: JoinTypeEnum;

    RelatedReportEntityId?: number;
    RelatedEntityId: number;
    RelatedEntityAlias: string;
    RelatedColumnName: string;
}
